import {Filter} from '../core/filter/filter';

export class PurchaseProcessFilter extends Filter {
  text?: string;
  status?: string;
}
